import { data } from "react-router-dom";
import { axiosBase, errorHandler } from "./axios";

const getCategory = (data: any) => {
  return axiosBase.get("category/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const getCategoryParams = (data: any) => {
  return axiosBase.get("category/list", { params: data }).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const createCategory = (data: any) => {
  return axiosBase.post("category/save", data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const deleteCategory = (data: any) => {
  return axiosBase.delete(`category/delete/${data}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const toggleCategory = (data: any) => {
  return axiosBase.post(`category/save`, data).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

const viewCategory = (id: string) => {
  return axiosBase.get(`category/view/${id}`).
  then((response) => response.data).
   catch((error) => errorHandler(error));
}

export const categoryService = {
  createCategory,
  getCategory,
  getCategoryParams,
  deleteCategory,
  toggleCategory,
  viewCategory
};